import { MarketAsset } from "./market-asset";

export type MarketAssetUid = typeof MarketAssetUid.Type;
export type MarketAssetUidEncoded = typeof MarketAssetUid.Encoded;

export const MarketAssetUid = MarketAsset.pick(
  "protocolKey",
  "marketAddress",
  "tokenAddress"
).annotations({ identifier: "MarketAssetUid" });
